import * as CrossFetch from 'cross-fetch';

import Language from '@root/components/language';
import Config from '@root/config';

/*
 * A class used to send requests to the API and handle error responses.
 */
export default class Communication {
    static async fetch(url: string, params?: any, element?: Element) : Promise<Response | null> {
        let response: Response | null = null;
        try {
            response = await CrossFetch.fetch(url, params || { method: 'GET' });
        } catch (e) {
            console.error(e);
        }
        await this.handleResponse(response, element);
        return response;
    }

    static async fetchJson(url: string, params?: any, element?: Element) : Promise<ResponseData | null> {
        let response: Response | null = null;
        try {
            response = await CrossFetch.fetch(url, params || { method: 'GET' });
        } catch (e) {
            console.error(e);
        }
    
        let data;
        try {
            data = await response.json();
        } catch (e) {
            console.log(e);
        }
        
        return {
            status: response.status,
            data
        };
    }

    private static async handleResponse(response: Response | null, element?: Element) {
        //TODO: this method may not be needed anymore
        if (!response || (response.status >= 500 && response.status <= 599))
            console.error('Unexpected error');
        else if (response && response.status >= 400 && response.status <= 499) {
            let code = await response.json();
            console.error(response.status + ': ' + code);
        }
        
    }
}

interface ResponseData {
    status: number;
    data: any;
}